// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1S3GH","buttons":"PendingPaymentAlert_buttons__2QCN-"};